module.exports = __webpack_public_path__ + "static/media/filter.69205eb5.svg";